import { Box, useTheme } from "@mui/material";
import { LuCheck } from "react-icons/lu";

/**
 * StatusDot - Matches the reference design exactly:
 * - Active (true):  Light green circle (#659d33 at 15% opacity) + green checkmark
 * - Inactive (false): Plain gray circle
 */
export const StatusDot = (params) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const active = !!params.value;

    if (active) {
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        backgroundColor: "#659d33",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        boxShadow: "0 2px 4px rgba(101, 157, 51, 0.2)"
                    }}
                >
                    <LuCheck size={14} color="#ffffff" strokeWidth={3} />
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
                    border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                    flexShrink: 0,
                }}
            />
        </Box>
    );
};
